import appEnum from './appEnum';

type Role = string | undefined;

export const canManageOrgSettings = (role: Role) =>
  role === appEnum.Role.Admin || role === appEnum.Role.SuperAdmin;

export const canViewUsers = (role: Role) =>
  canManageOrgSettings(role) || role === appEnum.Role.Inköp || role === appEnum.Role.Kalkyl;

export const settingsPath = (role: Role) =>
  canManageOrgSettings(role) ? '/settings' : '/settings/users';
